<script lang="ts">
  import { navigate } from 'svelte-routing';
</script>

<svelte:head>
  <title>Unsubscribe Failed - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  <header>
    <h2>Unsubscribe Failed</h2>
  </header>

  <p>
    We couldn't find your subscription with that code.
  </p>
  <p>
    You may have already unsubscribed, or the link may be invalid.
  </p>
  <p>
    <a href="/" class="button" on:click|preventDefault={() => navigate('/')}>Return to home</a>
  </p>
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  #main > header:first-child {
    text-align: center;
  }

  @media screen and (max-width: 736px) {
    #main {
      padding: 2em;
    }
  }
</style>
